import React, { useState, useEffect, useRef, useCallback } from "react";
import TakafulDataService from "../services/TakafulService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const TakafulPr = (props) => {
  const [takaful, setTakaful] = useState([]);
  const takafulRef = useRef();
  takafulRef.current = takaful;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveTakaful = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    TakafulDataService.getAll(target)
      .then((response) => setTakaful(response.data || []))
      .catch((e) => { console.error(e); setTakaful([]); });
  }, [owner]);

  useEffect(() => { retrieveTakaful(); }, [retrieveTakaful]);

  const deleteTakaful = useCallback((rowIndex) => {
    const id = takafulRef.current[rowIndex].id || takafulRef.current[rowIndex]._id;
    TakafulDataService.remove(id)
      .then(() => {
        const newArr = [...takafulRef.current];
        newArr.splice(rowIndex, 1);
        setTakaful(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/takaful/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/takaful/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = takafulRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteTakaful(idx);
  }, [deleteTakaful]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={takaful}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default TakafulPr;
